/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonskinddirections3Inputs */

const en_listingbuttonskinddirections3 = /** @type {(inputs: Listingbuttonskinddirections3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directions`)
};

const de_listingbuttonskinddirections3 = /** @type {(inputs: Listingbuttonskinddirections3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Route`)
};

/**
* | output |
* | --- |
* | "Directions" |
*
* @param {Listingbuttonskinddirections3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonskinddirections3 = /** @type {((inputs?: Listingbuttonskinddirections3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonskinddirections3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonskinddirections3(inputs)
	return de_listingbuttonskinddirections3(inputs)
});
export { listingbuttonskinddirections3 as "listingButtonsKindDirections" }